var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-tooltip",
        {
          attrs: { top: "" },
          scopedSlots: _vm._u([
            {
              key: "activator",
              fn: function (ref) {
                var on = ref.on
                var attrs = ref.attrs
                return [
                  _c(
                    "v-btn",
                    _vm._g(
                      _vm._b(
                        {
                          staticClass: "camera-plus-btn",
                          attrs: {
                            icon: "",
                            color: "primary",
                            disabled: _vm.readonly,
                            small: "",
                          },
                          on: { click: _vm.openModal },
                        },
                        "v-btn",
                        attrs,
                        false
                      ),
                      on
                    ),
                    [_c("v-icon", [_vm._v("mdi-plus")])],
                    1
                  ),
                ]
              },
            },
          ]),
        },
        [
          _c("span", [
            _vm._v(" " + _vm._s(_vm.$t("message.checklist.uploadDocument"))),
          ]),
        ]
      ),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "500", persistent: "" },
          model: {
            value: _vm.dialog,
            callback: function ($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog",
          },
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                { staticClass: "d-flex align-center justify-space-between" },
                [
                  _c("span", [_vm._v(_vm._s(_vm.label))]),
                  _c(
                    "v-btn",
                    { attrs: { icon: "" }, on: { click: _vm.closeModal } },
                    [_c("v-icon", [_vm._v("mdi-close")])],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-card-text",
                [
                  !_vm.showCamera && !_vm.capturedImage
                    ? _c(
                        "v-btn",
                        {
                          attrs: {
                            block: "",
                            color: "primary",
                            disabled: _vm.readonly,
                          },
                          on: { click: _vm.startCamera },
                        },
                        [
                          _c("v-icon", { attrs: { left: "" } }, [
                            _vm._v("mdi-camera"),
                          ]),
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("message.checklist.openCamera")) +
                              " "
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.showCamera
                    ? _c("video", {
                        ref: "video",
                        staticClass: "my-3 camera-preview",
                        attrs: { autoplay: "", playsinline: "", width: "100%" },
                      })
                    : _vm._e(),
                  _c("canvas", {
                    ref: "canvas",
                    staticStyle: { display: "none" },
                  }),
                  _vm.capturedImage
                    ? _c("v-img", {
                        staticClass: "my-3",
                        attrs: {
                          src: _vm.capturedImage,
                          "max-width": "100%",
                          contain: "",
                        },
                      })
                    : _vm._e(),
                  _vm.showCamera
                    ? _c(
                        "v-btn",
                        {
                          staticClass: "mb-2",
                          attrs: { block: "", color: "success" },
                          on: { click: _vm.capturePhoto },
                        },
                        [
                          _c("v-icon", { attrs: { left: "" } }, [
                            _vm._v("mdi-camera-iris"),
                          ]),
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("message.checklist.takePhoto")) +
                              " "
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.capturedImage
                    ? _c(
                        "v-btn",
                        {
                          staticClass: "mb-2",
                          attrs: { block: "", color: "warning" },
                          on: { click: _vm.retakePhoto },
                        },
                        [
                          _c("v-icon", { attrs: { left: "" } }, [
                            _vm._v("mdi-refresh"),
                          ]),
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("message.checklist.retake")) +
                              " "
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    { attrs: { text: "" }, on: { click: _vm.closeModal } },
                    [
                      _vm._v(
                        " " + _vm._s(_vm.$t("message.common.cancel")) + " "
                      ),
                    ]
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "primary", disabled: !_vm.capturedImage },
                      on: { click: _vm.uploadPhoto },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("message.common.save")) + " ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }